import type { PropsWithChildren } from 'react';
import {
  ToolGroupBlock,
  useToolGroupCurrentToolName,
  useToolGroupLiveState
} from '@/components/assistant-ui/tool-group';
import {
  useThinkingLabel,
  type ThreadGroupPart
} from '@/components/assistant-ui/thread';
import { useMcpToolDisplayTitle } from './McpToolDisplayNames';

/** Tool group whose header shows the running step with its Persian title. */
export function McpToolGroup({
  group,
  children
}: PropsWithChildren<{ group: ThreadGroupPart }>) {
  const currentToolName = useToolGroupCurrentToolName(group.indices);
  const currentTitle = useMcpToolDisplayTitle(currentToolName ?? '');
  const live = useToolGroupLiveState(group.indices);
  const thinkingLabel = useThinkingLabel();

  return (
    <ToolGroupBlock
      count={group.indices.length}
      active={live === 'tool'}
      currentTool={currentToolName ? currentTitle : undefined}
      thinkingLabel={live === 'thinking' ? thinkingLabel : undefined}
    >
      {children}
    </ToolGroupBlock>
  );
}
